import React from 'react';
import styled from 'styled-components';
import Layout from 'gatsby-theme-core/src/layout/layout';
// import useMessagebubbleData from 'gatsby-theme-messagebubble/src/hooks/use-messagebubble-data';
// import Messagebubble from 'gatsby-theme-messagebubble/src/components/messagebubble';
import Footer from '../../components/footer';
import Header from '../../layouts/header';

// eslint-disable-next-line arrow-body-style
const PdVLayout = ({ children, preheader, ...props }) => {
  // useMessagebubbleData();
  return (
    <Layout {...props}>
      {preheader}
      <Header />
      <Main>{children}</Main>
      <Footer />
      {/* <Messagebubble /> */}
    </Layout>
  );
};

const Main = styled.main`
  background-color: ${(props) => props.theme.mainBackgroundColor};
`;

export default PdVLayout;
